import Text from 'core-system/Text'
import pxToRem from 'core-system/utils/pxToRem'
import React from 'react'
import styled from 'styled-components'

const Service = styled.div<{ onClick?: () => void }>`
  display: flex;
  height: 2.5rem;
  margin-right: 1.5rem;
  align-items: center;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};

  &:last-of-type {
    margin-right: unset;
    .serviceText {
      border-right: unset;
    }
  }
`

const AliasText = styled(Text)`
  white-space: nowrap;
`

const ServiceText = styled.div`
  padding: 0 1.5rem 0 1rem;
  border-right: 1px solid ${(props) => props.theme.palette.grey.grey300};
`

interface ScrollerElementProps {
  logoElement: React.ReactNode
  name: string
  subtitle?: string
  onClick?: () => void
}

const ScrollerElement = ({
  logoElement,
  name,
  subtitle,
  onClick,
}: ScrollerElementProps) => {
  return (
    <Service key={name} onClick={onClick}>
      {logoElement}
      <ServiceText className='serviceText'>
        <AliasText variant='action4' maxWidth={pxToRem(100)} hideOverflow>
          {name}
        </AliasText>
        {subtitle && (
          <Text capitalize hideOverflow variant='body2'>
            {subtitle}
          </Text>
        )}
      </ServiceText>
    </Service>
  )
}

export default ScrollerElement
